<template>
  <div class="page-header">
    <div class="title-wrapper">
      <h2 class="title" :style="{ color: tonal?.white.white }">
        {{ props.title }}
      </h2>
    </div>

    <div class="filter-wrapper">
      <w-select
        :value="value"
        :options="props.options.itemList"
        :placeholder="props.options._default"
        @change="handleSelected"
      />
    </div>
  </div>
</template>

<script setup>
  import { tonal } from '@/constants/tonal'

  import WSelect from '@/components/ui/Select'

  const props = defineProps({
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: null,
    },
    value: {
      type: String,
    },
  })
  const emit = defineEmits(['change'])

  const handleSelected = (event) => {
    if (event) {
      emit('change', event)
    }
  }
</script>

<style lang="scss" scoped>
  .page-header {
    display: flex;
    align-content: center;
    justify-content: flex-start;
    gap: 16px;
    padding: 34px 0;

    .title-wrapper {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 16px;

      .title {
        flex-shrink: 0;
        font-size: 24px;
        font-weight: 400;
        line-height: 36px;
        &::after {
          display: none;
        }
      }
    }
  }
</style>
